import React from 'react';
import { SkeletonBlock, SkeletonRegion } from '../../Components/BrandPresenceSkeleton';

/** How many rows a loading step draws: about as many as a step usually suggests. */
const ONBOARDING_SKELETON_ROW_COUNT = 4;

/**
 * The rows of an onboarding step drawn while its suggestions load, in the shape of the list items the
 * step renders once they arrive: a name, a line under it, and the actions on the right.
 */
export function GovernanceOnboardingListSkeleton({ label }: { label: string }) {
  return (
    <SkeletonRegion label={label} className="mb-6 space-y-3">
      {Array.from({ length: ONBOARDING_SKELETON_ROW_COUNT }, (_unused, row) => (
        <div key={row} aria-hidden="true" className="flex items-center gap-4 rounded-xl border border-slate-200/80 bg-white p-4 shadow-sm">
          <div className="min-w-0 flex-1 space-y-2">
            <SkeletonBlock className={`h-4 ${row % 2 ? 'w-40' : 'w-56'}`} />
            <SkeletonBlock className="h-3 w-72 max-w-full" />
          </div>
          <SkeletonBlock className="h-8 w-8 rounded-lg" />
          <SkeletonBlock className="h-8 w-8 rounded-lg" />
        </div>
      ))}
    </SkeletonRegion>
  );
}
